import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { selectUser, selectIsUserAuthenticated } from '../Auth/selector';
import OwnerDashboard from './OwnerDashboard';
import SitterDashboard from './SitterDashboard';

// TODO: Remove dummy variable and integrate with backend
const tokens = 10;

const HomeComponent = () => {
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);
  const authenticatedUser = useSelector(selectUser);
  const history = useHistory();

  if (!isUserAuthenticated) {
    history.push('/login');
    return null;
  }

  const { isPetOwner } = authenticatedUser;

  return (
    <Container maxWidth="lg" sx={{ pt: 5 }}>
      <Typography variant="h6" component="h5">
        DogeCare Token Available: {tokens}
      </Typography>
      {isPetOwner ? <OwnerDashboard /> : <SitterDashboard />}
    </Container>
  );
};

export default HomeComponent;
